import React from "react"
import { Col, Row } from "react-bootstrap"
import { FeatureCatalogInfo } from "./ConversionRuleEditor"

const FeatureTypeRows = (props: { fcInfo: FeatureCatalogInfo; left: boolean }) => {
  const handleDragStart = (event: React.DragEvent<HTMLDivElement>) => {
    event.dataTransfer.setData("featureTypeSide", props.left ? "left" : "right")
    event.dataTransfer.setData("featureTypeId", event.currentTarget.id)
  }

  return (
    <>
      {props.fcInfo.featureTypes.map((feature) => {
        return (
          <Row key={feature.id} className="cre-list-hover px-2 cursor-pointer">
            <div id={"" + feature.id} draggable="true" onDragStart={handleDragStart} className="text-truncate py-1">
              {feature.name}
            </div>
          </Row>
        )
      })}
    </>
  )
}

export const FeatureTypeList = (props: { left: boolean; fcInfo: FeatureCatalogInfo }) => {
  return (
    <Col className={`ftRows h-100 ${props.left ? "border-right-dashed" : ""}`}>
      <FeatureTypeRows fcInfo={props.fcInfo} left={props.left} />
    </Col>
  )
}

export const FeatureTypeListHeading = (props: { left: boolean; fcInfo: FeatureCatalogInfo }) => {
  return (
    <Col className={`${props.left ? "cre-border-transparent" : ""}`}>
      <Row className="py-1 px-2">Feature Types</Row>
    </Col>
  )
}